"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentPin = exports.AssignmentPinSchema = void 0;
const lodash_1 = __importDefault(require("lodash"));
const pins_shared_1 = require("@lessonup/pins-shared");
const zod_1 = require("zod");
// TODO: commented for now
// export type TypeOfContent<P> = P extends AssignmentPin<infer C> ? C : never;
const DbIdentifiableSchema = zod_1.z.object({ _id: zod_1.z.string().min(1) });
// TODO: Decide whether to use id or _id in firestore documents, adding _id for now to make porting less painful
// export const AssignmentPinSchema = StudentPinSchema;
exports.AssignmentPinSchema = zod_1.z.discriminatedUnion('type', [
    // QuizStudentPinSchema.omit({ id: true }).merge(DbIdentifiableSchema),
    // SlideStudentPinSchema.omit({ id: true }).merge(DbIdentifiableSchema),
    // DragQuestionStudentPinSchema.omit({ id: true }).merge(DbIdentifiableSchema),
    // WordCloudStudentPinSchema.omit({ id: true }).merge(DbIdentifiableSchema),
    // VideoStudentPinSchema.omit({ id: true }).merge(DbIdentifiableSchema),
    // OpenQuestionStudentPinSchema.omit({ id: true }).merge(DbIdentifiableSchema),
    // LinkStudentPinSchema.omit({ id: true }).merge(DbIdentifiableSchema),
    // MapStudentPinSchema.omit({ id: true }).merge(DbIdentifiableSchema),
    // PollStudentPinSchema.omit({ id: true }).merge(DbIdentifiableSchema),
    pins_shared_1.QuizStudentPinSchema.merge(DbIdentifiableSchema),
    pins_shared_1.SlideStudentPinSchema.merge(DbIdentifiableSchema),
    pins_shared_1.DragQuestionStudentPinSchema.merge(DbIdentifiableSchema),
    pins_shared_1.WordCloudStudentPinSchema.merge(DbIdentifiableSchema),
    pins_shared_1.VideoStudentPinSchema.merge(DbIdentifiableSchema),
    pins_shared_1.OpenQuestionStudentPinSchema.merge(DbIdentifiableSchema),
    pins_shared_1.LinkStudentPinSchema.merge(DbIdentifiableSchema),
    pins_shared_1.MapStudentPinSchema.merge(DbIdentifiableSchema),
    pins_shared_1.PollStudentPinSchema.merge(DbIdentifiableSchema),
]);
// If this gives you an error, update the AssignmentPinSchema union
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ensureTypesAreInSync = true;
var AssignmentPin;
(function (AssignmentPin) {
    function isSlide(pin) {
        return pin.type === 'SLIDE';
    }
    AssignmentPin.isSlide = isSlide;
    function isVideo(pin) {
        return pin.type === 'VIDEO';
    }
    AssignmentPin.isVideo = isVideo;
    function isQuiz(pin) {
        return pin.type === 'MULTIPLE_CHOICE';
    }
    AssignmentPin.isQuiz = isQuiz;
    function isOpenQuestion(pin) {
        return pin.type === 'OPEN_QUESTION';
    }
    AssignmentPin.isOpenQuestion = isOpenQuestion;
    function isDragQuestion(pin) {
        return pin.type === 'DRAG_QUESTION';
    }
    AssignmentPin.isDragQuestion = isDragQuestion;
    function isWordCloud(pin) {
        return pin.type === 'WORD_CLOUD';
    }
    AssignmentPin.isWordCloud = isWordCloud;
    function isLink(pin) {
        return pin.type === 'LINK';
    }
    AssignmentPin.isLink = isLink;
    function isMap(pin) {
        return pin.type === 'MAP';
    }
    AssignmentPin.isMap = isMap;
    function isPoll(pin) {
        return pin.type === 'POLL';
    }
    AssignmentPin.isPoll = isPoll;
    /** creates a copy where the content has been removed */
    // export function pinWithoutContent(pin: AssignmentPin): AssignmentPin {
    //   const cleanedItem = _.pick(pin.item, ['custom.color', 'name', 'source', 'type']);
    //   _.set(cleanedItem, 'custom.answers', []);
    //   _.set(cleanedItem, 'components', []);
    //   return {
    //     ...pin,
    //     item: {
    //       ...cleanedItem,
    //       components: [],
    //     } as any,
    //   };
    // }
    // TODO @DAVEY: we probably need to remove / change this to use the 2.0 pins
    // export function assignmentPinFromLessonPin<T extends AssignmentPinContent = AssignmentPinContent>(
    //   lessonPin: LessonPin,
    //   isTest: boolean
    // ): AssignmentPin {
    //   return assignmentPinFromLessonPinItem(
    //     lessonPin.item,
    //     isTest,
    //     lessonPin._id,
    //     lessonPin.order,
    //     lessonPin.settings.timer,
    //     LessonPin.differentiation(lessonPin),
    //     lessonPin.parentPinId
    //   );
    // }
    function assignmentPinFromTeacherPin(teacherPin) {
        let studentSettings = {};
        if (teacherPin.type === 'MULTIPLE_CHOICE') {
            studentSettings = {
                hasCorrectAnswer: teacherPin.teacherSettings.correctAnswers.length > 0,
            };
        }
        if (teacherPin.type === 'OPEN_QUESTION') {
            studentSettings = {
                hasCorrectAnswer: teacherPin.teacherSettings.correctAnswers != null && teacherPin.teacherSettings.correctAnswers.length > 0,
                maximumNumberOfUploads: 0, // TODO: determine how many maximum uploads we allow
            };
        }
        if (teacherPin.type === 'DRAG_QUESTION') {
            studentSettings = {
                hasCorrectAnswer: false, // TODO, fix when we know how we store answers for dragQuestion
            };
        }
        return exports.AssignmentPinSchema.parse({
            ...teacherPin,
            _id: teacherPin.id, // TODO: @davey remove this if we decide to go for id
            studentSettings,
        });
    }
    AssignmentPin.assignmentPinFromTeacherPin = assignmentPinFromTeacherPin;
    // export function assignmentPinFromLessonPinItem<T extends AssignmentPinContent = AssignmentPinContent>(
    //   item: PinItem<LessonContent>,
    //   isTest: boolean,
    //   pinId: string,
    //   order: number,
    //   timer?: number,
    //   diff?: DiffLabel,
    //   parentPinId?: string
    // ): AssignmentPin {
    //   return {
    //     id: pinId,
    //     item: omitUndefined({
    //       custom: assignmentPinContentFromLessonPinItem(item, timer),
    //       name: item.name,
    //       testPoints: isTest ? LessonPin.testPointsForPinItem(item) : undefined,
    //       type: item.type,
    //       components: assignmentPinComponentsFromLessonPinItem(item),
    //       image: item.image,
    //       maxresImage: item.maxresImage,
    //       image2: item.image2,
    //       source: item.source,
    //       uploadId: item.uploadId,
    //       url: item.url,
    //       videoItems: item.videoItems,
    //       exclusions: item.exclusions,
    //       notes: item.notes,
    //       shuffleMap: item.shuffleMap,
    //       settings: item.settings,
    //       invalidVideo: item.invalidVideo,
    //     }),
    //     order,
    //     diff,
    //     parentPinId,
    //   };
    // }
    // export function lessonPinFromAssignmentPin(assignmentPin: AssignmentPin, meta: AssignmentMeta): LessonPin {
    //   const now = new Date();
    //   return {
    //     _id: assignmentPin._id,
    //     differentiation: assignmentPin.diff,
    //     order: assignmentPin.order || 0,
    //     timer: assignmentPin.settings.timer,
    //     parentPinId: assignmentPin.parentPinId,
    //     item: lessonPinItemFromAssignmentContent(assignmentPin, meta),
    //     creationDate: now,
    //     isPublic: true,
    //     lesson: meta.lessonId,
    //     user: meta.ownerId,
    //     shouldIndex: now,
    //   };
    // }
    // TODO: Remove?
    // export function lessonPinItemFromAssignmentContent<T extends LessonContent = LessonContent>(
    //   pin: AssignmentPin,
    //   meta: AssignmentMeta
    // ): PinItem {
    //   const pinId = pin._id;
    //   const pinItem: PinItem = _.cloneDeep(pin.item);
    //   switch (pin.type) {
    //     case 'OPEN_QUESTION':
    //       const pinContent = Pin.getContent(pin) as OpenQuestion.AssignmentContent;
    //       pinItem['custom'] = _.omit(OpenQuestion.LessonContent.fromAssignmentContent(pinId, pinContent, meta), [
    //         'hasAnswer',
    //         'maximumNumberOfUploads',
    //       ]);
    //       break;
    //     case 'MULTIPLE_CHOICE':
    //       Object.assign(
    //         pinItem.custom,
    //         QuizQuestion.Answer.convertAssignmentPinAnswersToLessonPinAnswers(
    //           pinId,
    //           Pin.getContent(pin) as QuizQuestion.AssignmentContent,
    //           meta
    //         )
    //       );
    //       pinItem.custom = _.omit(pinItem.custom, ['answerData', 'answers', 'hasAnswer']);
    //       break;
    //     default:
    //       break;
    //   }
    //   const lessonPinItem = {
    //     ...pinItem,
    //     components: pinItem.components,
    //   } as PinItem;
    //   if (pin.type === 'DRAG_QUESTION' && pinItem.components?.length) {
    //     const correctAnswers = AssignmentMeta.correctAnswerForPin<DragQuestion.CorrectAnswer>(meta, pinId);
    //     const updatedComponents = DragQuestion.Components.lessonComponentsFromAssignmentComponents(
    //       lessonPinItem.components || [],
    //       correctAnswers
    //     );
    //     lessonPinItem.components = updatedComponents;
    //   }
    //   return lessonPinItem;
    // }
    // TODO: it would be better to now copy the values, but the pick those one at a time (for compile safe reasons)
    function assignmentPinContentFromLessonPinItem(
    // item: PinItem,
    timer) {
        throw new Error('TODO: needs porting?');
        // let content: any = _.cloneDeep(item.custom);
        // switch (item.type) {
        //   case 'OPEN_QUESTION':
        //     _.set(content, 'maximumNumberOfUploads', OpenQuestion.LessonContent.maximumImageUploads(content));
        //     _.set(content, 'hasAnswer', !!content.answer);
        //     break;
        //   case 'MULTIPLE_CHOICE':
        //     content = convertQuizQuestionContentItem(item as PinItem, timer); // TODO Avoid cast somehow?
        //     break;
        //   case 'DRAG_QUESTION':
        //     _.set(content, 'hasAnswer', LessonPin.itemContainsCorrectAnswer(item));
        //     break;
        //   default:
        //     break;
        // }
        // // We always want to clear the answer
        // content = _.omit(content, ['answer', 'correctAnswer']);
        // return content;
    }
    // TODO: Remove (moved to root level)
    // function assignmentPinComponentsFromLessonPinItem(item: PinItem): Component.All[] {
    //   let components = (cloneDeepWithOptions(item.components, { replaceDateWithTimestamps: true }) ||
    //     []) as Component.All[];
    //   if (item.type === 'DRAG_QUESTION') {
    //     components = DragQuestion.Components.componentsWithoutCorrectAnswer(components);
    //   }
    //   components.map((c) => {
    //     if (c.type === 'table') {
    //       // tabledata is a multidimensional array, firebase does not support those
    //       const tableData = JSON.stringify(c.settings.tableData);
    //       c.settings = {
    //         ...c.settings,
    //         tableData,
    //       };
    //     }
    //     return c;
    //   });
    //   return components;
    // }
    function convertPinAnswers(content) {
        const { answer1, answer2, answer3, answer4 } = content;
        const contentAnswerData = content.answerData;
        const list = [answer1, answer2, answer3, answer4].map((answer, index) => {
            const answerData = lodash_1.default.get(contentAnswerData, 'answer' + (index + 1));
            const answerType = !answerData && lodash_1.default.isEmpty(answer) ? 'empty' : (answerData && answerData.type) || 'TEXT';
            const answerNumber = index + 1;
            return Object.assign({}, answerData, {
                value: answerNumber,
                type: answerType,
                text: answer || undefined,
            });
        });
        // remove empty starting from end
        for (let i = 3; i > 0; i--) {
            if (list[i].type === 'empty') {
                list.pop();
            }
            else {
                break;
            }
        }
        return list;
    }
    function convertQuizQuestionContentItem(
    // item: PinItem,
    timer) {
        throw new Error('TODO: needs porting?');
        // const content: QuizQuestion.LessonContent = item.custom;
        // return {
        //   ..._.omit(content, ['answer1', 'answer2', 'answer3', 'answer4', 'correctAnswer', 'answerData', 'timer']),
        //   hasAnswer: LessonPin.itemContainsCorrectAnswer(item),
        //   answers: convertPinAnswers(content),
        //   timer: timer === 0 ? undefined : timer,
        //   question: content.question,
        // };
    }
    function convertQuizQuestionContent(lessonPin) {
        throw new Error('TODO: needs porting?');
        // return convertQuizQuestionContentItem(lessonPin.item, lessonPin.settings.timer);
    }
    function timerForPin(pin) {
        const timer = pin.settings.timer;
        if (lodash_1.default.isNumber(timer)) {
            return timer;
        }
        return undefined;
    }
    AssignmentPin.timerForPin = timerForPin;
    function hasTestPoints(pin) {
        return !!pin.settings.testPoints;
    }
    AssignmentPin.hasTestPoints = hasTestPoints;
})(AssignmentPin || (exports.AssignmentPin = AssignmentPin = {}));
//# sourceMappingURL=AssignmentPin.js.map